/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _channelCell = _interopRequireDefault(require("./channelCell.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A cell for showing channel information such as the
 * channel's logo or title. Used together
 * with a ChannelColumn.
 *
 * @param {any} props See propTypes.
 * @returns {ChannelCell} A ChannelCell component
 */
var ChannelCell = function ChannelCell(_ref) {
  var _classNames;
  var channel = _ref.channel,
    width = _ref.width,
    height = _ref.height,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    onClick = _ref.onClick,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _channelCell["default"] : _ref$theme,
    isFocused = _ref.isFocused,
    _ref$nav = _ref.nav,
    nav = _ref$nav === void 0 ? {} : _ref$nav;
  var onMouseEnter = nav.onMouseOver,
    onMouseLeave = nav.onMouseOut;
  var _style = _objectSpread({
    width: width,
    minWidth: width,
    height: height || '100%',
    lineHeight: horizontal && height ? "".concat(height, "px") : ''
  }, style);
  var name = typeof channel === 'string' ? channel : channel.channelId;
  var className = (0, _classnames["default"])(theme.channelCell, (_classNames = {}, _defineProperty(_classNames, theme.channelClickable, !!onClick), _defineProperty(_classNames, theme.horizontal, horizontal), _defineProperty(_classNames, theme.focused, isFocused || nav && nav.isFocused), _classNames));
  var channelImage = (0, _get2["default"])(channel, 'images[0].url');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: _style
  }, channelImage ? /*#__PURE__*/_react["default"].createElement("img", {
    alt: channel.channelNumber || channel.channelId,
    className: theme.channelImage,
    src: channelImage
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.text
  }, name));
};
ChannelCell.propTypes = {
  /** The channel object for this cell */
  channel: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]).isRequired,
  /** The height of the cell */
  height: _propTypes["default"].number,
  /** If the channel cell is layed out horizontally */
  horizontal: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  nav: _propTypes["default"].object,
  /** Click handler, applied when clicking a channel cell */
  onClick: _propTypes["default"].func,
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    channelClickable: _propTypes["default"].string,
    channelName: _propTypes["default"].string,
    focused: _propTypes["default"].string,
    horizontal: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  /** The width of the cell */
  width: _propTypes["default"].number
};
var _default = /*#__PURE__*/_react["default"].memo(ChannelCell);
exports["default"] = _default;